import type { ProductKeys } from '../../constants/product-keys';
import type { FireAnalyticsEvent } from '../../types';
import type { CommonAttributes, NonPrivacySafeAttributes } from './types';

interface SearchPageThirdPartyLinkClickedProps {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	product: ProductKeys;
}

export const onFilterOptionTimeoutButtonClicked = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	product,
}: SearchPageThirdPartyLinkClickedProps): FireAnalyticsEvent => ({
	eventType: 'track',
	action: 'clicked',
	actionSubject: 'filterOptionTimeoutButton',
	attributes: {
		additionalAttributes: {
			product,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
